/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsTeamObjectivesDtoSchema = z.object({
  avgGrubs: z.optional(z.number()),
  avgTowers: z.optional(z.number()),
  avgDrakes: z.optional(z.number()),
  avgHeralds: z.optional(z.number()),
  avgBarons: z.optional(z.number()),
  avgBaronPowerPlayGold: z.number().nullish(),
});
